/**
 * Chooses the featured press article for the landing page.
 * Articles are expected already sorted date-desc.
 * Returns the first `featured: true` article (fallback: the first article),
 * plus the remaining articles with their order preserved.
 */
export function selectFeatured(articles) {
  const list = Array.isArray(articles) ? articles : []
  if (list.length === 0) {
    return { featured: null, rest: [] }
  }
  const featured = list.find((a) => a.featured) || list[0]
  const rest = list.filter((a) => a !== featured)
  return { featured, rest }
}
